import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getActiveTemplates, getArchivedTemplates, getSampleTemplates } from 'services/templates/review';

export const useGetActiveTemplatesQuery = () =>
  useQuery([REACT_QUERY_KEYS.reviewTemplateList.activeTemplates], () => getActiveTemplates({ offset: 0, limit: 5000 }));

export const useGetArchivedTemplatesQuery = () =>
  useQuery([REACT_QUERY_KEYS.reviewTemplateList.archivedTemplates], () =>
    getArchivedTemplates({ offset: 0, limit: 5000 })
  );

export const useGetSampleTemplatesQuery = () =>
  useQuery([REACT_QUERY_KEYS.reviewTemplateList.sampleTemplates], () => getSampleTemplates({ offset: 0, limit: 5000 }));
